import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function O2InfoMessage(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      elevation = props.elevation,
      noBorder = props.noBorder,
      noPadding = props.noPadding,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "color", "elevation", "noBorder", "noPadding"]);

  var classes = classNames(className, "o2-info-message", color ? "o2-info-message--" + color : false);
  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes
  }), children);
}

O2InfoMessage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.oneOf(["bad", "good", "neutral", "internal"])
};
export default O2InfoMessage;